import { render, staticRenderFns } from "./server-manage.vue?vue&type=template&id=aeb3338a&scoped=true&"
import script from "./server-manage.vue?vue&type=script&lang=js&"
export * from "./server-manage.vue?vue&type=script&lang=js&"
import style0 from "./server-manage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./server-manage.vue?vue&type=style&index=1&id=aeb3338a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb3338a",
  null
  
)

export default component.exports